import type { ID } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'
import type { ChangeBlockOrder } from '@store/blockSaga/types'

export const BlockActions = {
  changeBlockOrder: createAction<ChangeBlockOrder>('CHANGE_BLOCK_ORDER'),
  duplicateBlock: createAction<ID | undefined>('DUPLICATE_BLOCK'),
  deleteBlock: createAction('DELETE_BLOCK'),
  addBlock: createAction('ADD_BLOCK'),
  addBlockByPageContent: createAction('ADD_BLOCK_BY_PAGE_CONTENT'),
}
